export default __webpack_public_path__ + "dc996f178bf3f440f9634d3d94a1fb64.svg";